//
//
//
//
//
//

export default {
  methods: {
    scroll() {
      if (this.$refs.adBar !== undefined) {
        if (window.scrollY > 250) {
          this.$refs.adBar.style.opacity = '1'
        } else {
          this.$refs.adBar.style.opacity = '0'
        }
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scroll, false)
  }
}



// WEBPACK FOOTER //
// ./src/components/AdBar/AdBar.vue